/** @module ProductSpec/SizeChart/SizeChartSizeRangeRenderer */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/heading/ActionData",
	"csi/heading/Ref",
	"csi/xml",
	"csi/xml/Query",
	"./SizeChartSizesMixin"
], function(declare,lang,Action,ViewRef,ActionData,Ref,xml,Query,SizeChartSizesMixin) {

	return declare([Ref, SizeChartSizesMixin], {
		tagAction: "ActionSizeRange",

		_getStoreAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return Action including ViewRef and optionally Filter and FilterView to select defaults
			// if SizeChartRevision has 2-d SizeRange, only 2-d SizeRange of same Dimension1Type and Dimension1Type can be selected
			return lang.mixin(new Action(), {
				urlContext: this._getUrlContext(ctx),
				m_viewRef: lang.mixin(new ViewRef(), {
					m_url: "centric://APPAREL/Views",
					m_id: "SizeRanges"
				}),
				m_fixedQuery: this._getSizeRangeQuery(ctx)
			});
		},

		_getSizeRangeQuery: function(/*Context*/ctx) {
			var query = new Query()
				.Attr("OKforSizeChart", xml.OP_EQUALS, true)
				.Attr("Type", xml.OP_NOT_EQUALS, "SizeRangeType:");

			if (this._hasTwoDimSizeRange(ctx)) {
				// if SizeChartRevision has 2-d SizeRange, only 2-d SizeRange of same Dimension1Type and Dimension2Type can be selected
				var scRevision = ctx.getNode();
				query.Attr("Dimension1Type", xml.OP_EQUALS, scRevision.Dimension1Type)
					 .Attr("Dimension2Type", xml.OP_EQUALS, scRevision.Dimension2Type);
			}

			return query;
		},

		_getUrlContext: function(/*Context*/ctx) {
			// summary: construct the urlContext for SizeChartRevision aggregate SizeRange action
			// Since the variables on the query are the SizeChartRevision’s Dimension1Type and Dimension2Type, we use them as the urlContext.
			// It will work for 1-d SizeChartRevision too since the dimension1/2 types are all the same across all 1-d SizeChartRevision.
			var sizeChartRevision = this._getSizeChartRevision(ctx);
			return sizeChartRevision.Dimension1Type + " " + sizeChartRevision.Dimension2Type;
		},

		/**
		 * @overwrite
		 * Prevent requrring tooltip in Increment and ProductGroup popup views
		 */
		headingToTooltip: function(ctx, h, tooltip) {
			var viewId = ctx.defView.getId();
			if ((viewId == "Increment") || (viewId == "ProductGroup")){
				return null;
			} else {
				return this.inherited(arguments);
			}
		}

	});
});